/* Diagramming styles
 */

/* The diagram web component and its child canvas element */
keymap-diagram,
canvas.keyboard-diagram {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  overflow: visible;
}

/* A reference in prose to a key on the board.
 */
keymap-indicator {
  text-overflow: truncate;
  background-color: var(--_key-tgt-bg);
}
